import DataFormSubmitPage from 'app/pages/DataFormSubmit';
import React from 'react';

const HectoPaymentMob = () => {
  return <DataFormSubmitPage />;
};

export default HectoPaymentMob;
